import Stack, { StackProps } from '@mui/material/Stack'
import { ReactElement, ReactNode } from 'react';

export interface IActionBarProps extends StackProps {
    children?: ReactNode | ReactElement
}

export default function ActionBar({ children, ...other }: IActionBarProps) {
    return (
        <Stack direction={'row'} justifyContent={'flex-end'} spacing={2} px={3} py={2} borderTop={'1px solid'} borderColor={'divider'} {...other}>
            {children}
        </Stack>
    );
}
